import { filterParams, filterParamsExternal } from '../ecp-locator.cache';
import { TFiltersData } from '../../../models';

const setFilterParamsToCache = (value: TFiltersData) => {
  filterParams(value);
};

const setFilterParamsToCacheExternal = (value: TFiltersData) => {
  filterParamsExternal(value);
};

export const useSetFilterParams = () => ({
  setFilterParamsToCache,
  setFilterParamsToCacheExternal,
});
